module.exports = __webpack_public_path__ + "img/orange-and-yellow-lily.42ca3b02.jpg";